import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "filter-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_MateriallDescription = _resolveComponent("MateriallDescription")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'form-fullScreen': _ctx.isEdit && !_ctx.isEditInDialog })
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isShowAdd)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "filter-item",
                type: "primary",
                size: _ctx.t('table.btnSize'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCommand('add')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
                ]),
                _: 1
              }, 8, ["size"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        page: _ctx.listQuery.page,
        size: _ctx.listQuery.size,
        showSelection: false,
        canRefresh: false,
        canChangeColumn: false,
        isShowPagination: false,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        showSummary: true,
        onCommandChange: _ctx.handleCommand
      }, {
        "operation-action": _withCtx((scope) => [
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('delete', scope.row))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" 删除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_DELETE` }]
          ])
        ]),
        _: 1
      }, 8, ["dataList", "total", "columnAllData", "page", "size", "tableName", "permissionName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible && !_ctx.isEditInDialog)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.activeId)
            ? (_openBlock(), _createBlock(_component_FormComponent, {
                key: 0,
                id: _ctx.activeId,
                initFormData: _ctx.initFormData,
                fromFieldData: _ctx.fromFieldData,
                dialogFormVisible: _ctx.dialogFormVisible,
                api: _ctx.addPathApi,
                handleResolveTempData: _ctx.handleResolveTempData,
                "onUpdate:visibel": _cache[1] || (_cache[1] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
                onSubmit: _cache[2] || (_cache[2] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
              }, {
                front: _withCtx(() => [
                  _createVNode(_component_MateriallDescription, { detail: _ctx.materialInfo }, null, 8, ["detail"])
                ]),
                _: 1
              }, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api", "handleResolveTempData"]))
            : (_openBlock(), _createBlock(_component_FormComponent, {
                key: 1,
                id: _ctx.activeId,
                initFormData: _ctx.initEditFromData,
                fromFieldData: _ctx.editFromData,
                dialogFormVisible: _ctx.dialogFormVisible,
                api: _ctx.editPathPai,
                method: "PUT",
                "onUpdate:visibel": _cache[3] || (_cache[3] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
                onSubmit: _cache[4] || (_cache[4] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
              }, {
                front: _withCtx(() => [
                  _createVNode(_component_MateriallDescription, { detail: _ctx.materialInfo }, null, 8, ["detail"])
                ]),
                _: 1
              }, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api"]))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isEditInDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dialogFormVisible,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
          title: "编辑价格信息",
          width: "80%",
          "append-to-body": "",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormComponent, {
              id: _ctx.activeId,
              initFormData: _ctx.initEditFromData,
              fromFieldData: _ctx.editFromData,
              dialogFormVisible: _ctx.dialogFormVisible,
              api: _ctx.editPathPai,
              method: "PUT",
              "onUpdate:visibel": _cache[5] || (_cache[5] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
              onSubmit: _cache[6] || (_cache[6] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
            }, {
              front: _withCtx(() => [
                _createVNode(_component_MateriallDescription, { detail: _ctx.materialInfo }, null, 8, ["detail"])
              ]),
              _: 1
            }, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 2))
}